import React from 'react';
// import PageHeader from '../../components/headers/PageHeader';
import { Tabs, Card } from 'antd';
import TabContratosTrabajadores from './components/TabContratosTrabajadores';
import TabTurnosTrabajadores from './components/TabTurnosTrabajadores';
import TabContratosObraFaena from './components/TabContratosObraFaena';

export default function FirmasPendientesM() {
  return (
    <div>
      {/* <PageHeader title="Contratos" head="Trabajadores" /> */}
      <Card>
        <Tabs defaultActiveKey="1" type="card" size={'small'}>
          <Tabs.TabPane tab="Contratos Trabajadores" key="1">
            <TabContratosTrabajadores />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Contratos Obra Faena" key="2">
            <TabContratosObraFaena />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Turnos Trabajadores" key="3">
            <TabTurnosTrabajadores />
          </Tabs.TabPane>
        </Tabs>
      </Card>
    </div>
  );
}
